import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "kn-detail"
}
const _hoisted_2 = { class: "p-fluid p-m-3" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-d-flex p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedFolder.name), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit,
          "data-test": "submit-button"
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplate
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (!_ctx.selectedFolder.id || _ctx.selectedFolder.parentId)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_Card, { class: "p-m-3" }, {
            content: _withCtx(() => [
              _createVNode("form", _hoisted_2, [
                _createVNode("div", {
                  class: "p-field",
                  style: _ctx.detailDescriptor.pField.style
                }, [
                  _createVNode("span", _hoisted_3, [
                    _createVNode(_component_InputText, {
                      id: "label",
                      class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.selectedFolder.code.$invalid && _ctx.v$.selectedFolder.code.$dirty
                                }],
                      type: "text",
                      modelValue: _ctx.v$.selectedFolder.code.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.selectedFolder.code.$model = $event)),
                      modelModifiers: { trim: true },
                      maxLength: "100",
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.selectedFolder.code.$touch())),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
                      "data-test": "code-input"
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    vComp: _ctx.v$.selectedFolder.code,
                    additionalTranslateParams: {
                                fieldName: _ctx.$t('common.label')
                            }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ], 4),
                _createVNode("div", {
                  class: "p-field",
                  style: _ctx.detailDescriptor.pField.style
                }, [
                  _createVNode("span", _hoisted_5, [
                    _createVNode(_component_InputText, {
                      id: "name",
                      class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.selectedFolder.name.$invalid && _ctx.v$.selectedFolder.name.$dirty
                                }],
                      type: "text",
                      modelValue: _ctx.v$.selectedFolder.name.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.selectedFolder.name.$model = $event)),
                      modelModifiers: { trim: true },
                      maxLength: "255",
                      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.selectedFolder.name.$touch())),
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched'))),
                      "data-test": "name-input"
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    vComp: _ctx.v$.selectedFolder.name,
                    additionalTranslateParams: {
                                fieldName: _ctx.$t('common.name')
                            }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ], 4),
                _createVNode("div", {
                  class: "p-field",
                  style: _ctx.detailDescriptor.pField.style
                }, [
                  _createVNode("span", _hoisted_7, [
                    _createVNode(_component_InputText, {
                      id: "description",
                      class: "kn-material-input",
                      type: "text",
                      modelValue: _ctx.selectedFolder.description,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedFolder.description = $event)),
                      modelModifiers: { trim: true },
                      maxLength: "255",
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched'))),
                      "data-test": "description-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.description')), 1)
                  ])
                ], 4)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Card, { class: "p-m-3" }, {
            header: _withCtx(() => [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                start: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.menuManagement.roles')), 1)
                ]),
                _: 1
              })
            ]),
            content: _withCtx(() => [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_DataTable, {
                    key: 0,
                    value: _ctx.roles,
                    dataKey: "id",
                    class: "p-datatable-sm kn-table",
                    responsiveLayout: "scroll",
                    "data-test": "roles-table"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "name",
                        header: _ctx.$t('managers.functionalitiesManagement.roles'),
                        sortable: true
                      }, null, 8, ["header"]),
                      _createVNode(_component_Column, {
                        header: _ctx.$t('managers.functionalitiesManagement.development'),
                        style: _ctx.detailDescriptor.checkboxColumns.style
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Checkbox, {
                            modelValue: slotProps.data.development,
                            "onUpdate:modelValue": ($event: any) => (slotProps.data.development = $event),
                            binary: true,
                            disabled: !slotProps.data['devRoles'].checkable
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["header", "style"]),
                      _createVNode(_component_Column, {
                        header: _ctx.$t('common.test'),
                        style: _ctx.detailDescriptor.checkboxColumns.style
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Checkbox, {
                            modelValue: slotProps.data.test,
                            "onUpdate:modelValue": ($event: any) => (slotProps.data.test = $event),
                            binary: true,
                            disabled: !slotProps.data['testRoles'].checkable
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["header", "style"]),
                      _createVNode(_component_Column, {
                        header: _ctx.$t('managers.functionalitiesManagement.execution'),
                        style: _ctx.detailDescriptor.checkboxColumns.style
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Checkbox, {
                            modelValue: slotProps.data.execution,
                            "onUpdate:modelValue": ($event: any) => (slotProps.data.execution = $event),
                            binary: true,
                            disabled: !slotProps.data['execRoles'].checkable
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["header", "style"]),
                      _createVNode(_component_Column, {
                        header: _ctx.$t('managers.functionalitiesManagement.creation'),
                        style: _ctx.detailDescriptor.checkboxColumns.style
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_Checkbox, {
                            modelValue: slotProps.data.creation,
                            "onUpdate:modelValue": ($event: any) => (slotProps.data.creation = $event),
                            binary: true,
                            disabled: !slotProps.data['createRoles'].checkable
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["header", "style"]),
                      _createVNode(_component_Column, { onRowClick: false }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("div", _hoisted_9, [
                            _createVNode(_component_Button, {
                              icon: "pi pi-check",
                              class: "p-button-link",
                              onClick: ($event: any) => (_ctx.checkAll(slotProps.data)),
                              disabled: slotProps.data.isButtonDisabled,
                              "data-test": 'check-all-' + slotProps.data.id
                            }, null, 8, ["onClick", "disabled", "data-test"]),
                            _createVNode(_component_Button, {
                              icon: "pi pi-times",
                              class: "p-button-link",
                              onClick: ($event: any) => (_ctx.uncheckAll(slotProps.data)),
                              disabled: slotProps.data.isButtonDisabled,
                              "data-test": 'uncheck-all-' + slotProps.data.id
                            }, null, 8, ["onClick", "disabled", "data-test"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}